import React from 'react';

import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';

export default function NoMobile(props) {
	return (
		<Row className="no-mobile h-100" noGutters={true}>
			<Container className="my-auto">
				<h1>Stereotypical <span className="text-warning">Gibberish</span></h1>
				<img
					src="https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/320/twitter/147/mobile-phone_1f4f1.png"
					alt="Mobile Phone"
				/>
				<h2>Switch to Desktop</h2>
				<p className="lead">You can't run this application on mobile... yet!</p>
			</Container>
		</Row>
	);
}
